export const INCORPORATION_FILE_MAX_BYTES = 10 * 1024 * 1024;
export const INCORPORATION_DESCRIPTION_MAX = 1000;

const ALLOWED_EXTENSIONS = new Set(['pdf', 'doc', 'docx', 'jpg', 'jpeg', 'png']);

export const incorporationFileAccept = '.pdf,.doc,.docx,.jpg,.jpeg,.png';

export const incorporationFileError = (file: Pick<File, 'name' | 'size'>): 'fileType' | 'fileTooLarge' | null => {
  const extension = file.name.split('.').pop()?.toLowerCase() ?? '';
  if (!file.name.includes('.') || !ALLOWED_EXTENSIONS.has(extension)) return 'fileType';
  if (file.size > INCORPORATION_FILE_MAX_BYTES) return 'fileTooLarge';
  return null;
};
